if (!customElements.get('colour-request')) {
  customElements.define(
    'colour-request',
    class ColourRequest extends HTMLElement {
      connectedCallback() {
        this.variantIds = this.dataset.variantIds.split(',').filter(Boolean);
        this.form = this.closest('form');
        this.radios = this.querySelectorAll('input[type="radio"]');
        this.error = this.querySelector('.colour-request__error');
        this.name = this.querySelector('[data-colour-name]');

        // Runs before the add to cart handler, so an order can't go through without a colour.
        this.form.addEventListener('submit', (event) => this.checkColour(event), true);

        this.radios.forEach((radio) =>
          radio.addEventListener('change', () => {
            this.name.textContent = radio.value;
            this.error.hidden = true;
          })
        );

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId && !this.form.getAttribute('id').includes(data.sectionId)) return;
          this.sync(data.variant ? String(data.variant.id) : '');
        });

        this.sync(this.form.querySelector('input[name="id"]').value);
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      sync(variantId) {
        this.active = this.variantIds.includes(variantId);
        this.hidden = !this.active;
        this.radios.forEach((radio) => (radio.disabled = !this.active));

        // Express checkout can skip the colour, so it is hidden for colour requests.
        const express = this.form.querySelector('.shopify-payment-button');
        if (express) express.style.display = this.active ? 'none' : '';
      }

      checkColour(event) {
        if (!this.active || this.querySelector('input[type="radio"]:checked')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.error.hidden = false;
        this.scrollIntoView({ block: 'center', behavior: 'smooth' });
        this.radios[0].focus({ preventScroll: true });
      }
    }
  );
}
